import React from 'react';
import { observer } from "mobx-react";
import moment from 'moment'

import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import FigureCaption from '../components/FigureCaption';

import {regionCovidDataStore, stateCovidDataStore} from '../store/apiStores'

function createChartData(data, guidelines) {
    let chartData = {
        'name': 'Population Covid',
        'data': []
    };

    if (data) {
        let seriesData = {};
        if (guidelines == 'cdc'){
            seriesData = use_cdc_guidelines(data)
        }
        if (guidelines == 'wa'){
            seriesData = use_wa_guidelines(data)
        }
        chartData['data'] = Object.values(seriesData);
    }
    return chartData;
}

function use_cdc_guidelines(data) {
    let seriesData = {};
    data.forEach(function(v){
        let datetime = parseInt(moment.utc(v.report_date).format('x'))
        if (!seriesData['Lowest']) {
            seriesData['Lowest'] = {name: 'Lowest', color: '#4c830c', data: []}
        }
        seriesData['Lowest']['data'].push([datetime, v.population_in_lowest_cdc_pct])
        if (!seriesData['Lower']) {
            seriesData['Lower'] = {name: 'Lower', color: '#84bc4a', data: []}
        }
        seriesData['Lower']['data'].push([datetime, v.population_in_lower_cdc_pct])
        if (!seriesData['Moderate']) {
            seriesData['Moderate'] = {name: 'Moderate', color: '#ffe97d', data: []}
        }
        seriesData['Moderate']['data'].push([datetime, v.population_in_moderate_cdc_pct])
        if (!seriesData['Higher']) {
            seriesData['Higher'] = {name: 'Higher', color: '#ffad42', data: []}
        }
        seriesData['Higher']['data'].push([datetime, v.population_in_higher_cdc_pct])
        if (!seriesData['Highest']) {
            seriesData['Highest'] = {name: 'Highest', color: '#FF4500', data: []}
        }
        seriesData['Highest']['data'].push([datetime, v.population_in_highest_cdc_pct])
        if (!seriesData['2.5x Highest']) {
            seriesData['2.5x Highest'] = {name: '2.5x Highest', color: '#FF0000', data: []}
        }
        seriesData['2.5x Highest']['data'].push([datetime, v.population_in_highest_25x_cdc_pct])
        if (!seriesData['5x Highest']) {
            seriesData['5x Highest'] = {name: '5x Highest', color: '#B22222', data: []}
        }
        seriesData['5x Highest']['data'].push([datetime, v.population_in_highest_5x_cdc_pct])
    });
    return seriesData
}

function use_wa_guidelines(data) {
    let seriesData = {};
    data.forEach(function(v){
        let datetime = parseInt(moment.utc(v.report_date).format('x'))
        if (!seriesData['Low']) {
            seriesData['Low'] = {name: 'Low', color: '#00ff00', data: []}
        }
        seriesData['Low']['data'].push([datetime, v.population_in_low_14_day_pct])
        if (!seriesData['Medium']) {
            seriesData['Medium'] = {name: 'Medium', color: '#ffc387', data: []}
        }
        seriesData['Medium']['data'].push([datetime, v.population_in_medium_14_day_pct])
        if (!seriesData['High']) {
            seriesData['High'] = {name: 'High', color: '#ff0000', data: []}
        }
        seriesData['High']['data'].push([datetime, v.population_in_high_14_day_pct])
    });
    return seriesData
}

function createChartOptions(props) {
    let customOptions = {};
    if (props.state) {
        customOptions['title_text'] = `${props.state} State COVID-19 by infection rate category`
        customOptions['subtitle_text'] = '% of state population living within each covid rate level'
    } else if (props.region){
        customOptions['title_text'] = `${props.region} COVID-19 by infection rate category`
        customOptions['subtitle_text'] = '% of region population living within each covid rate level'
    } else {
        customOptions['title_text'] = `${props.county} County COVID-19 by infection rate category`
        customOptions['subtitle_text'] = '% of county population living within each covid rate level'
    }
    customOptions['height'] = null
    customOptions['width'] = null
    customOptions['tooltip'] = true
    customOptions['labels'] = true
    customOptions['hover'] = true
    customOptions['marker'] = false
    return customOptions;
}

function thirtydaysago(data) {
    if (!data || data.length == 0 || !data[0].data || data[0].data.length == 0) {
        // data hasn't loaded yet
        return null;
    }
    let last_dates = []
    data.forEach(function(v){
        v.data.sort()
        last_dates.push(v.data[v.data.length - 1][0])
    });
    let last_day = Math.max(...last_dates)
    return(last_day - ((24*60*60*1000) * 30))
}

export default observer(function RegionstateCovidAreachart(props) {
    let chartData = {data:[]};
    let customOptions = createChartOptions(props);
    if (props.state){
        chartData = createChartData(stateCovidDataStore.data, props.confirmedLast14Per100kAssessmentType);
    } else if (props.region) {
        chartData = createChartData(regionCovidDataStore.data, props.confirmedLast14Per100kAssessmentType);
    }

    let options = {
        series: chartData.data,

        chart: {
            type: 'area',
            height: customOptions.height,
            width: customOptions.width,
            zoomType: 'x'
        },

        credits: {
            enabled: false
        },

        title: {
            text: customOptions.title_text,
            align: 'left'
        },

        subtitle: {
            text: customOptions.subtitle_text,
            align: 'left'
        },

        yAxis: {
            min: 0,
            max: 100,
            labels: {
                enabled: customOptions.labels,
                format: '{value}%'
            },
            title: {
                enabled: false
            },
            opposite: true
        },

        xAxis: {
            type: 'datetime',
            labels: {
                enabled: customOptions.labels
            },
            dateTimeLabelFormats: {
                month: '%e. %b',
                year: '%b'
            }
        },

        tooltip: {
            enabled: customOptions.tooltip,
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.1f}%</b><br/>',
            split: true
        },

        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            x: 0,
            y: 0
        },

        plotOptions: {
            area: {
                stacking: 'normal',
                lineColor: '#ffffff',
                lineWidth: 1,
                marker: {
                    lineColor: '#ffffff'
                }
            },
            series: {
                marker: {
                    enabled: customOptions.marker,
                    symbol: 'circle'
                },
                dataLabels: {
                    enabled: false
                },
                states: {
                    hover: {
                        enabled: customOptions.hover
                    },
                    inactive: {
                        opacity: 1
                    }
                }
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    xAxis: {
                        max: null,
                        min: thirtydaysago(chartData.data)
                    }
                }
            }]
        }

    }

    if (chartData.data.length > 0) {
        return (
            <div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options} />
                <FigureCaption short_caption={'% Population in each COVID rate category.'} caption={'Percent population living in each category of COVID infection rate level (based on CDC or state guidelines per selector above). Aggregated from county infection rate assessments.'} />
                <br />
            </div>
        )
    } else {
        return null
    }
})
